import { type FC, useState } from 'react';
import { useTranslation } from 'react-i18next';

import cn from 'classnames';

import { ImageLightbox } from './ImageLightbox';
import type { PostMediaImage } from './PostMediaFrame';

interface ZoomableImageProps {
  images: PostMediaImage[];
  index?: number;
  className?: string;
  imageClassName?: string;
}

export const ZoomableImage: FC<ZoomableImageProps> = ({ images, index = 0, className, imageClassName }) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const image = images[index];

  return (
    <>
      <button
        type="button"
        aria-label={t('community.post.lightbox.open')}
        onClick={() => setIsOpen(true)}
        className={cn('cursor-zoom-in', className)}
      >
        <img
          src={image.src}
          alt={image.alt}
          loading="lazy"
          decoding="async"
          referrerPolicy="no-referrer"
          className={imageClassName}
        />
      </button>
      {/* Mounted per open so the lightbox always starts on the image that was clicked. */}
      {isOpen && <ImageLightbox images={images} initialIndex={index} onClose={() => setIsOpen(false)} />}
    </>
  );
};
